import { SERVICE_PILL_ORDER } from "../constants";
import { cx } from "../cx";
import { useQuoteCopy } from "../i18n/QuoteCopyContext";
import { ServiceActiveMapper } from "../serviceActive";
import type { FormState, ServiceKey } from "../types";
import { CloseIcon, PlusIcon } from "./icons";

const activeOf = new ServiceActiveMapper();

interface Props {
  form: FormState;
  onToggle: (key: ServiceKey, active: boolean) => void;
  labels?: Partial<Record<ServiceKey, string>>;
  keys?: ServiceKey[];
  locked?: ServiceKey[];
}

export function ServicePills({
  form,
  onToggle,
  labels,
  keys = SERVICE_PILL_ORDER,
  locked = [],
}: Props) {
  const copy = useQuoteCopy();
  return (
    <div
      className="nv-svc-pills"
      role="group"
      aria-label={copy.t("services.aria")}
    >
      {keys.map((key) => {
        const lockedOn = locked.includes(key);
        const active = lockedOn || activeOf.active(form, key);
        const label = labels?.[key] ?? copy.servicePill(key);
        return (
          <button
            key={key}
            type="button"
            id={`nv-svc-pill-${key}`}
            className={cx("nv-svc-pill", active && "on", key === "time" && "nv-svc-pill-time")}
            aria-pressed={active}
            aria-expanded={active}
            aria-controls={active ? `nv-svc-${key}` : undefined}
            disabled={lockedOn}
            onClick={() => {
              if (!lockedOn) onToggle(key, !active);
            }}
          >
            {lockedOn ? null : active ? <CloseIcon size={13} /> : <PlusIcon size={13} />}
            {label}
          </button>
        );
      })}
    </div>
  );
}
